import React from 'react'

const MajorBall = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21.79 10A9.351 9.351 0 0021 7.62a9.94 9.94 0 00-3.74-4.12 9.4 9.4 0 00-2.05-1L15 2.45A9.65 9.65 0 0012.73 2H12a9.88 9.88 0 00-6.56 2.46l-.18.16a10.83 10.83 0 00-1.51 1.73A10 10 0 002 11.59V12c0 .672.068 1.342.2 2v.05a9.5 9.5 0 00.8 2.33 10.15 10.15 0 003.61 4.05c.673.42 1.395.756 2.15 1a9.714 9.714 0 002.42.48h.74a9.87 9.87 0 004.68-1.17 9.203 9.203 0 001.93-1.33l.11-.1a10.003 10.003 0 001.54-1.78A9.82 9.82 0 0022 12.38V12c0-.672-.07-1.342-.21-2zm-7.32 4.8l-3.53.75-2.56-2.85 1.14-3.5 3.64-.77 2.48 2.77-1.17 3.6zm5.65-5.32l-3.36.71-2.49-2.76 1.05-3.25a8.54 8.54 0 014.8 5.3zM12 3.5a8 8 0 011.9.22L12.84 7l-3.61.78-2.3-2.6A8.41 8.41 0 0112 3.5zM5.8 6.19l2.29 2.55L7 12.24 3.55 13v-1A8.46 8.46 0 015.8 6.19zm-1.94 8.26l3.43-.73 2.46 2.74-1.08 3.36a8.53 8.53 0 01-4.81-5.37zM12 20.5a8.003 8.003 0 01-1.91-.22L11.15 17l3.64-.78 2.29 2.55A8.47 8.47 0 0112 20.5zm6.2-2.7l-2.3-2.55 1.15-3.54 3.39-.71a8.47 8.47 0 01-2.24 6.8z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorBall
